import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

/**
 * Ensures any internal relative link is correctly prefixed with the current locale
 * while passing external URLs, mailto, tel, and hashes through untouched.
 */
export function localizeLink(href: string | undefined | null, locale: string): string {
    if (!href) return `/${locale}`;
    
    // If it is an external URL, mailto, tel, or anchor link, return it as-is
    if (
        href.startsWith('http://') || 
        href.startsWith('https://') || 
        href.startsWith('mailto:') || 
        href.startsWith('tel:') || 
        href.startsWith('#')
    ) {
        return href;
    }
    
    // Standardize path to make sure it starts with a slash
    const cleanHref = href.startsWith('/') ? href : `/${href}`;
    
    // If it's already localized (e.g. /en/contact or /ar/contact), return it as-is
    if (cleanHref.startsWith(`/${locale}/`) || cleanHref === `/${locale}`) {
        return cleanHref;
    }
    
    // Otherwise, prefix it with the locale
    return `/${locale}${cleanHref}`;
}
